<template>
    <div class="gas">
        <!-- 最上面部分 -->
        <div class="gas-right--head">
            <span class="title">{{$store.state.shopInformation.shopName}}</span>
            <el-tag size="mini" effect="dark" style="margin:0 7px 0 11px;">打样</el-tag>
            <el-tag size="mini" effect="plain">VIP</el-tag>
        </div>
        <div class="gas-right--content">
            <!-- 加油站table -->
            <div class="table">
                <div class="table-flex">
                    <div class="table-input">
                        <el-button type="success" round @click="onAddInt">新增加油站</el-button>
                        <el-input
                            placeholder="请输入内容"
                            v-model="searchVal"
                            @input="searchChange"
                            style="width:180px;margin-left:18px;"
                        >
                            <el-button slot="append" icon="el-icon-search" @click="onGasSearch"></el-button>
                        </el-input>
                    </div>
                </div>
                <el-table :data="tableData" style="width: 100%;" v-loading="tabLoading">
                    <el-table-column prop="storeName" label="名称"></el-table-column>
                    <el-table-column prop="storeAddress" label="地址"></el-table-column>
                    <el-table-column prop="deviceCount" label="油枪数量"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button
                                type="primary"
                                round
                                size="small"
                                @click="onGasGunShow(scope.$index)"
                            >油枪管理</el-button>
                            <el-button
                                type="primary"
                                round
                                size="small"
                                @click="onGasGoodsShow(scope.$index)"
                            >油价设置</el-button>
                            <el-button
                                type="success"
                                round
                                size="small"
                                @click="onTableEdit(scope.row)"
                            >编辑</el-button>
                            <el-button
                                type="warning"
                                round
                                size="small"
                                @click="onEnable(scope.row)"
                            >{{scope.row.isEnable==1?'禁用':'启用'}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="gasIndex"
                    style="margin-top:20px;"
                    @current-change="onPageChange"
                    :page-size="row"
                ></el-pagination>
            </div>
        </div>
        <!-- 油价设置弹框 -->
        <el-dialog width="426px" :visible.sync="gasPriceShow" @close="gasGunClose">
            <div slot="title" class="gasGunDialog-title">
                <div
                    class="title"
                    v-if="tableShopIndex!=null"
                >{{tableData[tableShopIndex].storeName}}加油站</div>
            </div>
            <div
                class="alignCenter"
                style="margin-bottom:20px;"
                v-for="(item, index) in gasGoodsArr"
                :key="index"
            >
                <div
                    class="o-color-gray o-tar"
                    style="width:66px;margin-right:11px;"
                >{{item.industryGoodsDesc}}</div>
                <el-input
                    type="number"
                    placeholder="请输入价格"
                    v-model="item.price"
                    @blur
                    style="width:183px;"
                >
                    <div
                        slot="suffix"
                        style="line-height:40px;color:rgba(101,101,101,1);font-size:14px;"
                    >元/升</div>
                </el-input>
            </div>
            <el-button type="primary" round @click="onGoodsSave">保存</el-button>
        </el-dialog>

        <!-- 油枪设置弹框 -->
        <el-dialog
            width="426px"
            :visible.sync="gasGunShow"
            class="gasGunDialog"
            :show-close="false"
            @close="gasGunClose"
        >
            <div slot="title" class="gasGunDialog-title">
                <div
                    class="title"
                    v-if="tableShopIndex!=null"
                >{{tableData[tableShopIndex].storeName}}加油站</div>
                <el-button type="success" round @click="onGasAddGun">新建油枪</el-button>
            </div>
            <div class="o-clearfix">
                <div
                    class="gasGunDialog-button"
                    v-for="(item, index) in gasGunList"
                    :key="index"
                    :class="gasGunTabIndex==index?'active':''"
                    @click="onGasTab(index)"
                >
                    {{item.deviceNo}}号油枪{{item.industryGoodsDesc}}
                    <div class="gasGunDialog-close" @click="gunDelete(index)">
                        <i class="el-icon-close" style="color:#fff;"></i>
                    </div>
                </div>
            </div>
            <div class="o-flex o-alignCenter" v-if="gasGunList.length">
                <div class="gasGunDialog-text">油枪号</div>
                <el-input
                    v-model="gasGunValue"
                    placeholder="请输入内容"
                    style="width:183px;"
                    @input="gunValueChange"
                ></el-input>
            </div>
            <div class="o-flex o-alignCenter" v-if="gasGunList.length">
                <div class="gasGunDialog-text">油品</div>
                <el-select
                    v-model="gasGunGoodsIndex"
                    placeholder="请选择"
                    style="width:183px;"
                    @change="gunGoodsChange"
                >
                    <el-option
                        v-for="(item,index) in gasGoodsList"
                        :key="index"
                        :label="item.industryGoodsDesc"
                        :value="item.industryGoodsType"
                    ></el-option>
                </el-select>
            </div>
            <el-button type="primary" round style="margin-top:16px;" @click="onGasGunSubmit">保存</el-button>
            <el-button type="warning" round style="margin-top:16px;" @click="onGasGunClose">取消</el-button>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/assets/request.js";
import {
    gasStations,
    gasStationsCount,
    gasDevices,
    gasGoods,
    addOrUpdateGasDevice,
    delGasDevice,
    gasPrices,
    addOrUpdateGasPrice
} from "@/components/api/index.js";
export default {
    data() {
        return {
            gasPriceShow: false, //油价设置弹框
            gasAllPriceShow: false, //全部油价设置
            gasGunShow: false, //油枪设置弹框
            page: 1, //页数
            row: 10, //一页有几个
            gasIndex: 0, //加油站个数
            gasGunList: [], //油枪列表
            gasGunTabIndex: null, //油枪弹窗里tab里的索引
            gasGoodsList: [], //油品列表
            gasGunValue: "", //油枪弹窗里的 input值
            tableShopIndex: null, //当前table选中的加油站索引
            gasGunGoodsIndex: null, //油枪里选中油品的索引
            isAddGun: false,
            searchVal: "", //搜索内容
            tableData: [], //加油站列表
            gasGoodsArr: [], //当前油价列表
            tabLoading: false, //table加载中
            userList: []
        };
    },
    created() {
        this.userList = this.getCookie("userList")
            ? JSON.parse(this.getCookie("userList"))
            : "";
    },
    mounted() {
        this.onGasSearch();
        this.gasGoods();
    },
    methods: {
        onGasGunClose() {
            this.gasGunShow = false;
        },
        onAddInt() {
            this.$router.push("/gasAddInt");
        },
        gasStations() {
            //获取加油站列表
            this.tabLoading = true;
            return gasStations({
                storeName: this.searchVal,
                pageNo: this.page,
                row: this.row
            })
                .then(res => {
                    if (res.code == 1) {
                        this.tableData = res.data;
                    }
                    this.tabLoading = false;
                })
                .catch(err => {
                    this.tabLoading = false;
                });
        },
        gasStationsCount() {
            //获取加油站数量
            return gasStationsCount({
                storeName: this.searchVal
            }).then(res => {
                if (res.code == 1) {
                    this.gasIndex = res.data;
                }
            });
        },
        onPageChange(e) {
            //改变页数
            this.page = e;
            this.gasStations();
        },
        onTableEdit(e) {
            //编辑
            this.$router.push(`/gasAddInt?id=${e.shopStoreId}`);
        },
        onGasGunShow(i) {
            console.log(i);
            this.tableShopIndex = i;
            //显示油枪
            gasDevices({
                shopStoreId: this.tableData[this.tableShopIndex].shopStoreId,
                pageNo: 1,
                row: 1000
            }).then(res => {
                this.gasGunList = res.data != undefined ? res.data : [];
                this.gasGunList.forEach(e => {
                    this.gasGoodsList.forEach(j => {
                        if (e.industryGoodsType == j.industryGoodsType) {
                            e.industryGoodsDesc = j.industryGoodsDesc;
                        }
                    });
                });
                this.gasGunShow = true;
            });
        },
        onGasTab(e) {
            //油枪选择
            this.gasGunTabIndex = e;
            this.gasGunValue = this.gasGunList[e].deviceNo;
            this.gasGunGoodsIndex = this.gasGunList[e].industryGoodsType;
        },
        gasGoods() {
            //读取油品
            gasGoods().then(res => {
                if (res.code == 1) {
                    this.gasGoodsList = res.data;
                }
            });
        },
        onGasGunSubmit() {
            //更改油枪
            let i = this.gasGunTabIndex;
            let idx = this.gasGunGoodsIndex - 1;
            let form = {
                shopDeviceId: i ? this.gasGunList[i].shopDeviceId : "",
                shopStoreId: this.tableData[this.tableShopIndex].shopStoreId,
                industryGoodsType: this.gasGunList[i].industryGoodsType,
                deviceNo: this.gasGunList[i].deviceNo,
                isEnable: 1
            };

            addOrUpdateGasDevice(form).then(res => {
                if (res.code == 1) {
                    this.$notify({
                        title: "成功",
                        message: "保存成功",
                        type: "success",
                        duration: 6000
                    });
                    this.gasGunShow = false;
                } else {
                    this.$notify({
                        title: "警告",
                        message: res.msg,
                        type: "warning",
                        duration: 6000
                    });
                }
                console.log(res);
            });
        },
        onGasAddGun() {
            if (this.isAddGun == true) {
                this.$notify({
                    title: "警告",
                    message: "请先保存新建的油枪",
                    type: "warning",
                    duration: 6000
                });
                return;
            }
            this.gasGunTabIndex = this.gasGunList.length;
            this.gasGunList.push({
                deviceNo: "",
                industryGoodsType: null,
                industryGoodsDesc: ""
            });
            this.isAddGun = true;
        },
        gunValueChange(e) {
            //更改油枪号Value
            this.gasGunList[this.gasGunTabIndex].deviceNo = e;
        },
        gunGoodsChange(e) {
            //油枪油品更改
            this.gasGoodsList.forEach(el => {
                this.gasGunList[this.gasGunTabIndex].industryGoodsType = e;
                if (el.industryGoodsType == e) {
                    this.gasGunList[this.gasGunTabIndex].industryGoodsDesc =
                        el.industryGoodsDesc;
                }
            });
        },
        gasInit() {
            //清空
            this.gasGunTabIndex = null; //清空油枪弹窗里table里的索引
            this.gasGunGoodsIndex = null; //清空油枪里选中油品的索引
            this.tableShopIndex = null; //清空当前加油站的id
            this.gasGunValue = ""; //清空油枪弹窗里的 input值
            this.isAddGun = false;
            this.gasGoodsArr = []; //清空单个店铺的油价
        },
        gasGunClose() {
            this.gasInit();
        },
        gunDelete(i) {
            //删除油枪
            this.$confirm("是否删除此油枪", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    delGasDevice({
                        shopDeviceId: this.gasGunList[i].shopDeviceId,
                        shopStoreId: this.tableData[this.tableShopIndex]
                            .shopStoreId
                    }).then(res => {
                        if (res.code == 1) {
                            this.gasGunShow = false;
                            this.$message({
                                type: "success",
                                message: "删除成功!"
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        async onGasSearch() {
            //搜索加油站
            await this.gasStations();
            await this.gasStationsCount();
        },
        onGasGoodsShow(i) {
            this.tableShopIndex = i;
            this.gasPrices();
        },
        searchChange(e) {
            if (e == "") {
                this.onGasSearch();
            }
        },
        gasPrices() {
            gasPrices({
                shopStoreId:
                    this.tableShopIndex != null
                        ? this.tableData[this.tableShopIndex].shopStoreId
                        : ""
            }).then(res => {
                if (this.tableShopIndex == null) {
                    this.gasAllPriceShow = true;
                } else {
                    this.gasPriceShow = true;
                }

                let gasGoodsArr =
                    res.data != undefined
                        ? JSON.parse(JSON.stringify(res.data))
                        : [];
                if (gasGoodsArr.length) {
                    this.gasGoodsList.forEach((element, index) => {
                        gasGoodsArr.forEach(e => {
                            if (gasGoodsArr[index]) {
                                if (
                                    e.industryGoodsType ==
                                    element.industryGoodsType
                                ) {
                                    e.industryGoodsDesc =
                                        element.industryGoodsDesc;
                                }
                            } else {
                                gasGoodsArr[index] = {
                                    industryGoodsType:
                                        element.industryGoodsType,
                                    price: "",
                                    industryGoodsDesc: element.industryGoodsDesc
                                };
                            }
                        });
                    });
                } else {
                    this.gasGoodsList.forEach((element, index) => {
                        gasGoodsArr[index] = {
                            industryGoodsType: element.industryGoodsType,
                            price: "",
                            industryGoodsDesc: element.industryGoodsDesc
                        };
                    });
                }

                this.gasGoodsArr = gasGoodsArr;
            });
        },
        onGoodsSave() {
            let arr = [];
            this.gasGoodsArr.forEach(e => {
                arr.push({
                    industryGoodsType: e.industryGoodsType,
                    price: e.price
                });
            });
            addOrUpdateGasPrice({
                shopStoreId: this.tableData[this.tableShopIndex].shopStoreId,
                shopPriceJson: JSON.stringify(arr)
            }).then(res => {
                if (res.code == 1) {
                    this.$notify({
                        title: "成功",
                        message: "保存成功",
                        type: "success",
                        duration: 6000
                    });
                    this.gasPriceShow = false;
                } else {
                    this.$notify({
                        title: "警告",
                        message: res.msg,
                        type: "warning",
                        duration: 6000
                    });
                }
                console.log(res);
            });
        },
        goodsChange(e, i) {
            // this.gasGoodsArr[e].price =
            console.log(e, i);
        },
        onEnable(i) {
            this.$confirm(
                `是否${i.isEnable == 1 ? "禁用" : "启动"}该加油站`,
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                }
            ).then(() => {
                updateGasStationEnable({
                    shopStoreId: i.shopStoreId,
                    isEnable: i.isEnable == 1 ? 0 : 1
                }).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "操作成功!"
                        });
                        this.onGasSearch();
                    } else {
                        this.$notify({
                            title: "警告",
                            message: res.msg,
                            type: "warning",
                            duration: 6000
                        });
                    }
                });
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.gas {
    width: calc(100vw - 200px);
    height: calc(100vh);
    margin-left: 200px;
    min-width: 1340px;
    background-color: #f8f8f8;
}
.gas-right--head {
    height: 66px;
    line-height: 66px;
    background-color: #fff;
    padding-left: 31px;
    font-size: 20px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    display: inline-flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    z-index: 9;
}
.gas-right--content {
    padding: 87px 25px 0 28px;
    width: 100%;
    box-sizing: border-box;
}

.list {
    background-color: #fff;
    height: 124px;

    .item {
        box-sizing: border-box;
        padding-left: 33px;
        padding-top: 24px;
        float: left;
        margin-right: 1%;
        width: calc(96% / 5);
        display: flex;
        border-radius: 10px;
        &:nth-child(5) {
            margin-right: 0;
        }
        .icon {
            width: 66px;
            height: 66px;
        }
        .right {
            padding: 9px 0 0 28px;
            .text {
                line-height: 1;
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                margin-bottom: 13px;
            }
            .sum {
                line-height: 1;
                font-size: 30px;
                font-weight: 400;
                color: rgba(17, 17, 17, 1);
            }
        }
    }
}
.clearfix {
    margin-bottom: 30px;
    padding-top: 25px;
    // min-width: 1650px;
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    .left {
        // float:left;
        max-width: 1152px;
        width: 100%;
        padding: 0 25px 0 17px;
        background-color: #fff;
        height: 200px;
        box-sizing: border-box;
        .o-title {
            margin: 18px 0 23px 0;
        }
        .manage-list {
            overflow: hidden;
            .item {
                margin-right: 30px;
                display: flex;
                float: left;
                justify-content: space-between;
                position: relative;
                width: 350px;
                height: 116px;
                border-radius: 10px;
                overflow: hidden;
                &:nth-child(1) {
                    background: rgba(236, 245, 255, 1);
                    .btn {
                        background: rgba(67, 160, 255, 1);
                    }
                }
                &:nth-child(2) {
                    background: rgba(240, 249, 235, 1);
                    .btn {
                        background: #67c23a;
                    }
                }
                &:nth-child(3) {
                    margin-right: 0;
                    background: rgba(254, 240, 240, 1);
                    .btn {
                        background: rgba(245, 108, 108, 1);
                    }
                }
                .font {
                    padding: 0 18px 0 29px;
                    .text {
                        margin: 33px 0 13px;
                        font-size: 16px;
                        font-weight: bolder;
                        color: rgba(17, 17, 17, 1);
                        line-height: 1;
                    }
                    .p {
                        font-size: 12px;
                        font-weight: 400;
                        color: rgba(102, 102, 102, 1);
                        line-height: 1;
                    }
                }
                .btn {
                    cursor: pointer;
                    margin: 34px 38px 0 0;
                    width: 104px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    border-radius: 20px;
                    color: #fff;
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                }
                img {
                    position: absolute;
                    bottom: -4px;
                    left: -4px;
                }
            }
        }
    }
    .right {
        flex: 1;
        // float:right;
        height: 200px;
        max-width: 480px;
        // width: 100%;
        background: rgba(255, 255, 255, 1);
        .title {
            padding: 19px 0 0 17px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(17, 17, 17, 1);
            line-height: 1;
            margin-bottom: 20px;
        }
        .no {
            text-align: center;
            .no-title {
                font-size: 18px;
                font-weight: 400;
                color: rgba(17, 17, 17, 1);
                line-height: 1;
            }
            .no-text {
                margin: 18px 0 23px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 1;
            }
        }
        .yes {
            text-align: center;
            .yes-title {
                font-size: 16px;
                font-weight: 400;
                color: rgba(17, 17, 17, 1);
                line-height: 1;
            }
            .yes-text {
                font-size: 16px;
                font-weight: 400;
                color: rgba(101, 101, 101, 1);
                line-height: 1;
                margin: 20px 0 20px 0;
            }
        }
    }
}
.table {
    background-color: #fff;
    padding: 18px 20px 30px 17px;
    .table-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/page/gasSite.vue